/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/switch/custom-elements';

import { defineCustomElement as defineOsdsSwitch } from '@ovhcloud/ods-stencil/components/switch/custom-elements/osds-switch.js';
import { defineCustomElement as defineOsdsSwitchItem } from '@ovhcloud/ods-stencil/components/switch/custom-elements/osds-switch-item.js';

export const OsdsSwitch = /*@__PURE__*/createReactComponent<JSX.OsdsSwitch, HTMLOsdsSwitchElement>('osds-switch', undefined, undefined, defineOsdsSwitch);
export const OsdsSwitchItem = /*@__PURE__*/createReactComponent<JSX.OsdsSwitchItem, HTMLOsdsSwitchItemElement>('osds-switch-item', undefined, undefined, defineOsdsSwitchItem);
